@if (currentModule) {
<div
  class="flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200 flex-shrink-0"
>
  <div class="flex items-center gap-2">
    <i class="bi bi-folder text-gray-600"></i>
    <h2 class="text-base font-semibold text-gray-900 leading-none">
      {{ currentModule.name }}
    </h2>
    @if (!isPreviewMode) {
    <button
      type="button"
      class="btn-icon ml-2"
      (click)="onEditModule(currentModule.id)"
      title="Editar Módulo"
      aria-label="Editar Módulo"
    >
      <i class="bi bi-pencil text-xs"></i>
    </button>
    <button
      type="button"
      class="btn-icon btn-icon-danger"
      (click)="onDeleteModule(currentModule.id)"
      title="Excluir Módulo"
      aria-label="Excluir Módulo"
    >
      <i class="bi bi-trash text-xs"></i>
    </button>
    }
  </div>
  <div class="flex items-center gap-2">
    <button
      type="button"
      class="inline-flex items-center gap-x-2 rounded px-3 py-2 text-sm font-medium transition-colors focus:outline-none"
      (click)="onTogglePreview()"
      [ngClass]="{
          'bg-[var(--color-primary-soft)] text-[var(--color-primary)] hover:bg-[var(--color-primary-muted)]': isPreviewMode,
          'bg-gray-50 text-gray-700 hover:bg-gray-100': !isPreviewMode
        }"
    >
      <i class="bi" [ngClass]="isPreviewMode ? 'bi-eye-slash' : 'bi-eye'"></i>
      <span>{{ isPreviewMode ? 'Sair do Preview' : 'Preview' }}</span>
    </button>
    @if (!isPreviewMode) { @if (currentModule.contentType === 'lessons') {
    <button
      type="button"
      class="btn-primary inline-flex items-center gap-x-2 px-3 py-2"
      (click)="onAddLesson(currentModule.id)"
    >
      <i class="bi bi-plus-circle"></i>
      <span>Adicionar Lição</span>
    </button>
    } @else if (currentModule.contentType === 'evaluations') {
    <button
      type="button"
      class="btn-primary inline-flex items-center gap-x-2 px-3 py-2"
      (click)="onAddQuestion(currentModule.id)"
    >
      <i class="bi bi-plus-circle"></i>
      <span>Adicionar Questão</span>
    </button>
    } }
  </div>
</div>
}
